// assets
import { IconChartBar } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| ANALYTICS MENU ITEM ||============================== //

const icons = {
  IconChartBar
};

const analytics: NavItemType = {
  id: 'analytics',
  title: 'analytics',
  icon: icons.IconChartBar,
  type: 'group',
  url: '/analytics'
};

export default analytics;
